import type { CatalogItem } from '@/entities/catalog-item';
import type { SymbolKey } from '@/entities/symbol';

import type { Row } from '@tanstack/react-table';

export const parseForwardCurveRowToSymbol = (row: Row<CatalogItem>) => {
  const periodMin = Number(row.getValue<number>('PeriodMin'));
  const periodMax = Number(row.getValue<number>('PeriodMax'));
  const baseSymbol = row.getValue<SymbolKey | undefined>('Symbol');
  const selectedSymbols: SymbolKey[] = [];
  if (!baseSymbol) return selectedSymbols;
  for (let i = periodMin; i <= periodMax; i++) {
    selectedSymbols.push({
      Code: baseSymbol.Code,
      TimeRef: baseSymbol.TimeRef,
      Period: i.toString(),
      PeriodType: baseSymbol.PeriodType
    });
  }
  return selectedSymbols;
};
